import { PageState } from 'models/PageState';

export const isStartPage = (state: PageState) => state.currentPage.pageName === 'StartPage';
